import api from '../lib/axios';
/**
 * Uploads an image to the generic backend endpoint and returns its URL.
 * `module` groups files server-side (var/uploads/{commune}/{module}/…).
 * Server enforces JPG/PNG/WebP (plus PDF with type 'all'), max 10 MB.
 */
export async function uploadImage(file, module, type = 'image') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', module);
    formData.append('type', type);
    const { data } = await api.post('/api/v1/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.url;
}
